$(document).on('click','.accordianItem',function(){
    $('.accordianItem').children('.answer').addClass('hidden').removeClass('visible');
    $(this).children('.answer').removeClass('hidden').addClass('visible');
})

$(document).on('click', '.product-info-swatch', function(){
    $('.product-info-swatch').removeClass('selected');
    $(this).addClass('selected');
    $('.single-option-selector').val($(this).data('color')).change();
    $('.product-select').val($(this).data('variant')).change();
    $('.product-thumbnails').find('[data-variant="'+$(this).data('variant')+'"]').click();
    $('.current_option_value').html($(this).data('color')).change();
    var saleprice = $(this).data('compareprice');
    var result = typeof saleprice;
    // alert( saleprice);
    if(result === 'string'){
        var element = document.getElementById("onsalebanner");
        //element.classList.add("hidethis");
    } else {
        var element = document.getElementById("onsalebanner");
        $('.salepricedisplay').html('AUD$'+($(this).data('price')/100));
        //element.classList.remove("hidethis");
    }
})

function scrollToContent(){   
    var ele = document.getElementById('shopify-section-1557440988413');
    $('html, body').animate({scrollTop:ele.offsetTop+150},'50');
}
/*
$(window).scroll(function() {
    if ($(this).scrollTop() > 150) {
      $('.scroller-holder').fadeOut();
    } else {
      $('.scroller-holder').fadeIn();
    }
});
*/
 